<template>
  <div>
    <div v-if="item">
      <div>
        <div class="card">
          <!-- card left -->
          <div class="product-imgs">
            <div class="img-display">
              <div class="img-showcase">
                <img
                  :src="
                    imagesLength > 0
                      ? item.images[0]
                      : '/images/products/no-photo.jpg'
                  "
                />
                <img
                  :src="
                    imagesLength > 0
                      ? item.images[1]
                      : '/images/products/no-photo.jpg'
                  "
                />
                <img
                  :src="
                    imagesLength > 0
                      ? item.images[2]
                      : '/images/products/no-photo.jpg'
                  "
                />
                <img
                  :src="
                    imagesLength > 0
                      ? item.images[3]
                      : '/images/products/no-photo.jpg'
                  "
                />
              </div>
            </div>
            <div class="img-select">
              <div class="img-item" v-if="imagesLength > 0 && item.images[0]">
                <a href="#" data-id="1">
                  <img
                    :src="
                      imagesLength > 0
                        ? item.images[0]
                        : '/images/products/no-photo.jpg'
                    "
                  />
                  <v-btn
                    x-small
                    v-if="!item.images[0].includes('no-photo')"
                    color="red"
                    dark
                    @click="deleteImage(item.images[0])"
                  >
                    <v-icon dark>mdi-delete</v-icon>Delete
                  </v-btn>
                </a>
              </div>
              <div class="img-item" v-if="imagesLength > 0 && item.images[1]">
                <a href="#" data-id="2">
                  <img
                    :src="
                      imagesLength > 0
                        ? item.images[1]
                        : '/images/products/no-photo.jpg'
                    "
                  />
                  <v-btn
                    x-small
                    color="red"
                    dark
                    @click="deleteImage(item.images[1])"
                  >
                    <v-icon dark>mdi-delete</v-icon>Delete
                  </v-btn>
                </a>
              </div>
              <div class="img-item" v-if="imagesLength > 0 && item.images[2]">
                <a href="#" data-id="3">
                  <img
                    :src="
                      imagesLength > 0
                        ? item.images[2]
                        : '/images/products/no-photo.jpg'
                    "
                  />
                  <v-btn
                    x-small
                    color="red"
                    dark
                    @click="deleteImage(item.images[2])"
                  >
                    <v-icon dark>mdi-delete</v-icon>Delete
                  </v-btn>
                </a>
              </div>
              <div class="img-item" v-if="imagesLength > 0 && item.images[3]">
                <a href="#" data-id="4">
                  <img
                    :src="
                      imagesLength > 0
                        ? item.images[3]
                        : '/images/products/no-photo.jpg'
                    "
                  />
                  <v-btn
                    x-small
                    color="red"
                    dark
                    @click="deleteImage(item.images[3])"
                  >
                    <v-icon dark>mdi-delete</v-icon>Delete
                  </v-btn>
                </a>
              </div>
            </div>
          </div>
          <!-- card right -->
          <div class="product-content">
            <h2 class="product-title">
              <v-text-field
                class="mx-4"
                v-model="item.name"
                label="Item Name"
                @change="updateModel('name')"
              ></v-text-field>
            </h2>
            <a href="#" class="product-link" v-if="item.category">{{
              item.category.name
            }}</a>
            <!-- <div class = "product-rating">
        <i class = "fas fa-star"></i>
        <i class = "fas fa-star"></i>
        <i class = "fas fa-star"></i>
        <i class = "fas fa-star"></i>
        <i class = "fas fa-star-half-alt"></i>
        <span>4.7(21)</span>
      </div> -->

            <div class="product-price">
              <p class="new-price">
                Item Cost:
                <input
                  class="ml-2"
                  :size="8"
                  :style="{
                    border: 'none',
                    'border-bottom': '1px solid black',
                    'margin-top': '2px',
                  }"
                  @blur="updateModel('cost', $event)"
                  :value="getCurrency + formatMoney(item.cost)"
                />
              </p>
              <p class="new-price">
                {{ division == "Products" ? "Item Price" : "Fee Per Hour" }}:

                <input
                  class="ml-2"
                  :size="8"
                  :style="{
                    border: 'none',
                    'border-bottom': '1px solid black',
                    'margin-top': '2px',
                  }"
                  @blur="updateModel('price', $event)"
                  :value="getCurrency + formatMoney(item.price)"
                />
              </p>
            </div>

            <div class="product-detail">
              <h2>Description:</h2>
              <p>
                <v-text-field
                  class="mx-4"
                  v-model="item.description"
                  label="Item Description"
                  @change="updateModel('description')"
                ></v-text-field>
              </p>

              <ul>
                <li>
                  Item Type:
                  <span>{{ capitalizeFirstCharacter(item.item_type) }}</span>
                </li>
                <li v-if="division == 'Product'">
                  Stock Available:
                  {{ item.inventory.quantity_in_stock }}
                </li>
                <li v-if="item.category">
                  Category: <span>{{ item.category.name }}</span>
                </li>
                <li>
                  Item Code:
                  <input
                    class="ml-2"
                    :size="6"
                    :style="{
                      border: 'none',
                      'border-bottom': '1px solid black',
                      'margin-top': '2px',
                    }"
                    @blur="updateModel('code', $event)"
                    :value="item.code"
                  />
                </li>
                <li>
                  Listed On Store:
                  <input
                    class="ml-2"
                    :size="6"
                    :style="{
                      border: 'none',
                      'border-bottom': '1px solid black',
                      'margin-top': '2px',
                    }"
                    @blur="updateModel('list_on_store', $event)"
                    :value="capitalizeFirstCharacter(item.list_on_store)"
                  />
                </li>
              </ul>
            </div>

            <div class="purchase-info">
              <!-- <input type = "number" min = "0" value = "1"> -->
              <button type="button" class="btn" @click="goTo('/switchboard')">
                Switchboard <i class="fas fa-shopping-cart"></i>
              </button>
              <button type="button" class="btn">
                <v-icon left dark>mdi-delete</v-icon>Delete
              </button>
            </div>

            <div class="social-links">
              <p>Share At:</p>
              <a href="#">
                <i class="fab fa-facebook-f"></i>
              </a>
              <a href="#">
                <i class="fab fa-twitter"></i>
              </a>
              <a href="#">
                <i class="fab fa-instagram"></i>
              </a>
              <a href="#">
                <i class="fab fa-whatsapp"></i>
              </a>
              <a href="#">
                <i class="fab fa-pinterest"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
import imagesJs from "@/plugins/images";
export default {
  props: {
    itemProp: {
      default: null,
    },
    division: {
      default: "Products",
    },
  },
  watch: {
    itemProp(newItem) {
      this.setItem(newItem);
    },
    division() {
      this.setItem(null);
    },
  },
  computed: {
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
  },
  mounted() {
    this.setItem(this.itemProp);
  },
  data: () => ({
    item: null,
    imagesLength: 0,
  }),
  methods: {
    goTo(route) {
      this.$router.push({ path: route });
    },
    capitalizeFirstCharacter(str) {
      return helpersJs.capitalizeFirstCharacter(str);
    },
    formatMoney(amount) {
      return helpersJs.formatMoney(amount);
    },
    setItem(item) {
      this.item = item;
      if (
        this.itemProp &&
        this.itemProp.images &&
        this.itemProp.images.length
      ) {
        this.imagesLength = this.itemProp.images.length;
      }
    },
    stripCommasFromMoney(amount) {
      return helpersJs.stripCommasFromMoney(amount);
    },
    updateModel(column, event = null) {
      if (this.division && this.item && this.item.id) {
        const table = this.division.toLowerCase();

        event && event.target ? (this.item[column] = event.target.value) : "";

        if (column == "cost" || column == "price") {
          this.item[column] = this.stripCommasFromMoney(this.item[column]);
        }

        this.$store.commit("setLoader", true);
        helpersJs.updateModelSingleRow(
          table,
          column,
          this.item.id,
          this.item[column]
        );
        this.$store.commit("setLoader", false);
        this.$toast.success("Item Updated Successfully!");
      }
    },
    async deleteImage(imagePath) {
      this.$store.commit("setLoader", true);

      const parts = imagePath.split("/");
      const imageName = parts[parts.length - 1];

      const imageFolderPathWithinPublic =
        "images/items/" + this.getUserCompany.emis + "/" + this.item.link;
      const images = await imagesJs.deleteImage(
        imageFolderPathWithinPublic,
        imageName
      );

      this.item.images = await imagesJs.getImagesPublicFullPath(
        imageFolderPathWithinPublic,
        images
      );
      this.$store.commit("setLoader", false);
    },
  },
};
</script>

<style scoped lang="scss">
@import url("./itemDetailStyles.css");
</style>
